import type { ShopCapability, StoreCapabilities } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";
import type { CapabilityAccess } from "../../core/primitives/capabilities";

export type Declined = StoreCapabilities["declined"][number];

export class CapabilityRequestState {
  constructor(readonly capability: ShopCapability) {}
  readonly access = new Rx<CapabilityAccess>("unknown");
  readonly error = new Rx<string | null>(null);
  /** Staff turned the last request down; set only while the shop could ask again. */
  readonly declined = new Rx<Declined | null>(null);
  /** The address HobbyScan answers at, prefilled from the shop's capabilities. */
  readonly contactEmail = new Rx("");
  readonly contactEmailError = new Rx<string | null>(null);
  /** Where the answer to a request made goes, when known. */
  readonly replyTo = new Rx<string | null>(null);
}

export abstract class CapabilityRequestActions {
  abstract setContactEmail(value: string): void;
  abstract request(): Promise<void>;
}
